// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19yWj","controls":"styles_controls__1SBSj","charLimit":"styles_charLimit__3YULx","input":"styles_input__21Qiw","send":"styles_send__33Iay"};